/* huebsches – kleine Ergänzungen zum Horizon-Theme (Relaunch 2026) */
(function () {
  'use strict';

  /* ---------- „Mehr anzeigen“ statt Seitenzahlen (Kollektion und Suche) ---------- */
  function ratingRefresh() {
    if (typeof window.ratingSnippet === 'function') {
      try {
        window.ratingSnippet('ruk_rating_snippet', {
          store: 'huebsches.com', mode: 'extended', color: '#B8860B', linebreak: false,
          text: 'Bewertungen', singularText: 'Bewertung', lang: 'de', usePolaris: true,
          showEmptyStars: false, showNumericalAverageRating: false
        });
      } catch (e) { /* still fine without stars */ }
    }
  }

  function totalCount(root) {
    var el = root.querySelector('.facets__count, [class*="results-count"], [class*="product-count"], [class*="facets__product-count"]');
    if (!el) {
      el = Array.prototype.find.call(root.querySelectorAll('.facets-block-wrapper *'), function (n) {
        return n.children.length === 0 && /\d+\s*(Artikel|Produkte|Ergebnisse)/.test(n.textContent);
      });
    }
    var m = el && el.textContent.match(/(\d+)/);
    return m ? parseInt(m[1], 10) : 0;
  }

  /* Aufruf mit ?page=N (Zurück ohne Browser-Zwischenspeicher, geteilter Link): die Artikel der Seiten 1 bis N-1
     vorne ergänzen, damit die Liste vollständig ist, und die gemerkte Scrollposition wiederherstellen. */
  function pageOf() { return parseInt(new URL(location.href).searchParams.get('page') || '1', 10) || 1; }
  function prependPrevious(grid, current, done) {
    if (current <= 1 || grid.dataset.hbPrepended) return;
    grid.dataset.hbPrepended = '1';
    var pages = [];
    for (var p = 1; p < current; p++) {
      var u = new URL(location.href); u.searchParams.set('page', String(p)); pages.push(u.toString());
    }
    Promise.all(pages.map(function (u) { return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.text(); }); }))
      .then(function (htmls) {
        var frag = document.createDocumentFragment();
        htmls.forEach(function (html) {
          var g = new DOMParser().parseFromString(html, 'text/html').querySelector('.product-grid');
          if (g) Array.prototype.forEach.call(g.querySelectorAll(':scope > li'), function (li) { frag.appendChild(document.importNode(li, true)); });
        });
        grid.insertBefore(frag, grid.firstChild);
        if (done) done();
        ratingRefresh();
        var saved = null;
        try { saved = sessionStorage.getItem('hb-scroll:' + location.pathname + location.search); } catch (err) { /* ignore */ }
        if (saved) window.scrollTo(0, parseInt(saved, 10));
      })
      .catch(function () { /* Liste bleibt wie geladen */ });
  }

  function setupLoadMore(nav) {
    if (nav.dataset.hbReady) return;
    nav.dataset.hbReady = '1';
    var results = nav.closest('results-list') || document;
    var grid = results.querySelector('.product-grid');
    if (!grid) return;
    var arrows = nav.querySelectorAll('.pagination__link--arrow');
    var nextA = arrows[arrows.length - 1];
    if (!nextA || nextA.tagName !== 'A' || nextA.classList.contains('pagination__link--disabled')) { nav.style.display = 'none'; prependPrevious(grid, pageOf()); return; }

    var wrap = document.createElement('div');
    wrap.className = 'hb-more';
    var btn = document.createElement('a');
    btn.className = 'button button-secondary hb-more__btn';
    btn.href = nextA.href;
    btn.textContent = 'Mehr anzeigen';
    var info = document.createElement('span');
    info.className = 'hb-more__info';
    var total = totalCount(results);
    var updateInfo = function () {
      var shown = grid.querySelectorAll(':scope > li').length;
      info.textContent = total ? shown + ' von ' + total + ' Artikeln' : '';
    };
    updateInfo();
    wrap.appendChild(btn); wrap.appendChild(info);
    nav.parentNode.insertBefore(wrap, nav);
    nav.hidden = true;

    function loadNext() {
      if (btn.classList.contains('is-loading') || btn.hidden) return Promise.resolve();
      btn.classList.add('is-loading');
      var url = btn.href;
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('.product-grid');
          var newNav = doc.querySelector('nav.pagination');
          if (newGrid) {
            Array.prototype.forEach.call(newGrid.querySelectorAll(':scope > li'), function (li) { grid.appendChild(document.importNode(li, true)); });
          }
          var newArrows = newNav ? newNav.querySelectorAll('.pagination__link--arrow') : [];
          var newNext = newArrows[newArrows.length - 1];
          if (newNext && newNext.tagName === 'A' && !newNext.classList.contains('pagination__link--disabled') && newNext.href !== url) {
            btn.href = newNext.href;
          } else {
            btn.hidden = true;
          }
          try { history.replaceState(null, '', url); } catch (err) { /* ignore */ }
          updateInfo();
          ratingRefresh();
        })
        .catch(function () { window.location.href = url; })
        .finally(function () { btn.classList.remove('is-loading'); });
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      loadNext();
    });

    /* Desktop und Tablet (ab 750 px): den zweiten 24er-Block automatisch laden, sobald das Ende der Liste naht,
       danach wieder per Button (Baymard: Mischform). Mobil bleibt es beim Button. Nur einmal je Seitenaufruf. */
    var current = pageOf();
    if (current === 1 && window.matchMedia('(min-width: 750px)').matches && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; })) { io.disconnect(); loadNext(); }
      }, { rootMargin: '0px 0px 600px 0px' });
      io.observe(wrap);
    }

    prependPrevious(grid, current, function () { updateInfo(); });
  }

  /* Scrollposition der Liste merken, damit sie nach dem Zurück wiederhergestellt werden kann */
  window.addEventListener('pagehide', function () {
    if (!document.querySelector('.hb-more')) return;
    try { sessionStorage.setItem('hb-scroll:' + location.pathname + location.search, String(Math.round(window.scrollY))); } catch (err) { /* ignore */ }
  });

  /* ---------- Startseite: Teaser-Kollektion verlinkt auf die echte Weihnachtskollektion ---------- */
  function fixTeaserLinks() {
    document.querySelectorAll('a[href$="/collections/startseite-weihnachten"]').forEach(function (a) {
      a.href = a.href.replace('/collections/startseite-weihnachten', '/collections/weihnachten');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixTeaserLinks); else fixTeaserLinks();

  /* ---------- Mobil: Suchzeile in voller Breite unter dem Kopf (öffnet den Suchdialog des Themes) ---------- */
  function mobileSearchRow() {
    var header = document.querySelector('header-component');
    if (!header || header.querySelector('.hb-msearch')) return;
    var top = header.querySelector('.header__row--top');
    var trigger = header.querySelector('.header__column--left search-button button, search-button button');
    if (!top || !trigger) return;
    var row = document.createElement('div');
    row.className = 'hb-msearch';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hb-msearch__btn';
    btn.setAttribute('aria-label', 'Suche öffnen');
    btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="M20 20l-3.5-3.5"></path></svg><span>Wonach suchst du?</span>';
    btn.addEventListener('click', function () {
      var t = header.querySelector('search-button:not([style*="display: none"]) button') || trigger;
      t.click();
    });
    row.appendChild(btn);
    top.insertAdjacentElement('afterend', row);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mobileSearchRow); else mobileSearchRow();

  /* ---------- Suche: nach Bestseller sortierte Treffer kommen alle auf einmal, hier in 24er-Schritten aufblenden ---------- */
  var HB_STEP = 24;
  function setupReveal(grid) {
    if (grid.dataset.hbReveal) return;
    var items = grid.querySelectorAll(':scope > li[data-hb-sorted]');
    if (!items.length) return;
    grid.dataset.hbReveal = '1';
    var total = items.length;
    if (total <= HB_STEP) return;
    var shown = HB_STEP;
    var apply = function () {
      Array.prototype.forEach.call(items, function (li, i) { li.hidden = i >= shown; });
      info.textContent = Math.min(shown, total) + ' von ' + total + ' Artikeln';
      if (shown >= total) btn.hidden = true;
    };
    var wrap = document.createElement('div');
    wrap.className = 'hb-more';
    var btn = document.createElement('a');
    btn.className = 'button button-secondary hb-more__btn';
    btn.href = '#';
    btn.setAttribute('role', 'button');
    btn.textContent = 'Mehr anzeigen';
    var info = document.createElement('span');
    info.className = 'hb-more__info';
    wrap.appendChild(btn); wrap.appendChild(info);
    grid.insertAdjacentElement('afterend', wrap);
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var first = items[shown];
      shown += HB_STEP;
      apply();
      ratingRefresh();
      if (first) { var a = first.querySelector('a'); if (a) a.focus({ preventScroll: true }); }
    });
    apply();
  }

  function init() {
    document.querySelectorAll('nav.pagination').forEach(setupLoadMore);
    document.querySelectorAll('.product-grid').forEach(setupReveal);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Horizon rendert Ergebnisliste und Empfehlungen nachträglich, und das REVIEWS.io-Skript lädt verzögert: Sterne neu zeichnen
  var starTimer = null;
  function starsPending() {
    return Array.prototype.some.call(document.querySelectorAll('.ruk_rating_snippet'), function (s) { return !s.querySelector('i') && !s.dataset.hbChecked; });
  }
  function refreshStars() {
    if (typeof window.ratingSnippet !== 'function') return;
    ratingRefresh();
    document.querySelectorAll('.ruk_rating_snippet').forEach(function (s) { s.dataset.hbChecked = '1'; });
  }
  function starsMissing() {
    return Array.prototype.some.call(document.querySelectorAll('.ruk_rating_snippet'), function (s) { return !s.querySelector('i'); });
  }
  window.addEventListener('load', function () {
    [300, 1200, 3000].forEach(function (d) { setTimeout(function () { if (starsMissing()) refreshStars(); }, d); });
  });
  new MutationObserver(function () {
    init();
    if (starsPending()) {
      clearTimeout(starTimer);
      starTimer = setTimeout(refreshStars, 300);
    }
  }).observe(document.body, { childList: true, subtree: true });

  /* ---------- Produktseite: „14 Tage Rückgabe“ öffnet „Versand und Rückgabe“, „Auch huebsch, oder?“ springt zu den Empfehlungen ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.hb-to-returns, a.hb-to-auch');
    if (!a) return;
    var target = null;
    if (a.classList.contains('hb-to-returns')) {
      var det = Array.prototype.find.call(document.querySelectorAll('.product-details details'), function (d) {
        var s = d.querySelector('summary'); return s && /Versand und R/.test(s.textContent);
      });
      if (det) { det.open = true; target = det; }
    } else {
      target = document.querySelector('[id$="__auch_huebsch"]');
    }
    if (!target) return;
    e.preventDefault();
    var head = parseInt(getComputedStyle(document.body).getPropertyValue('--header-height'), 10) || 0;
    var top = target.getBoundingClientRect().top + window.scrollY - head - 16;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  });
})();
